<template>
  <div id="admin-work-license-user-list">
    <!-- 当前考核的所有用户两场考试成绩列表 -->
    <diy_table
      :loading="loading"
      :buttonList="buttonList"
      :isSelect="true"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      :tableState="tableState"
      @handleClickTop="handleClickTop"
      @initTable="initTable"
      @handleClick="handleClick"
      @handleSelectionChange="handleSelectionChange"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as workLicenseData from "./js/work_license.js";
export default {
  data() {
    return {
      loading: false,
      tableState: true, // 表格中按钮是否跟随状态显示
      id: "",
      status: "", // 考核状态
      buttonList: this.$systemBaseData.getTopButArray("workLicenseUser"),
      tableMenu: this.$systemBaseData.getTableMenuData("workLicenseUser"),
      tableData: [],
      tableButton: this.$systemBaseData.getTableButtonList(
        "workLicenseUser",
        ""
      ),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 总条目数
      },

      tempUser: {},
      options: {
        opinion: [], // 考核意见
      },

      dialogData: {
        flag: false,
        title: "实操成绩导入",
        width: "40%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_choose_import_type" },
          { text: "取消", active: "cancel" },
        ],
      },
      multipleSelection: [],
      currentDate: new Date(),
    };
  },
  methods: {
    // 获取当前时间
    getCurrentDate() {
      let date = new Date();
      let year = date.getFullYear();
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    /**
     * 获取考核意见下拉框数据
     */
    async getListByType() {
      try {
        let resultData = await this.$request({
          url: "/dictionaries/getListByType",
          method: "post",
          data: { type: "examOpinion" },
        });
        this.options.opinion = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.mean,
            value: element.mean,
          };
          this.options.opinion.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 初始化表格操作
     */
    async initTable(data) {
      try {
        setTimeout(async () => {
          this.loading = true;
          let requestData = {
            id: this.id,
            currentPage: data.pageData.currentPage,
            pageSize: data.pageData.pageSize,
          };
          let resultData = await this.$request({
            url: "/workLicense/showUserWorkLicenseExamDetails",
            method: "post",
            data: requestData,
          });
          this.tableData = resultData.tableData;
          this.tableData.forEach((element) => {
            element.isPass = element.isPass ? "合格" : "不合格";
            let ss = element.certificateTime == "" ? element.isPass : "已发";
            this.$set(
              element,
              "butList",
              this.$systemBaseData.getTableButtonList("workLicenseUser", ss)
            );
            this.$set(
              element,
              "rowColor",
              element.isPass == "合格" ? "#22c02f" : "#EA5412"
            );
          });
          console.log(this.tableData);
          this.pageData.total = resultData.total;
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 搜索框边的按钮操作
     */
    async handleClickTop(active) {
      try {
        switch (active) {
          case "import":
            // 实操成绩导入
            let value = {
              way: "0", // 导入方式
              fileUrl: "", // 已上传的模板路径
              fileName: "", // 已上传的模板名称
              type: "3",
              wayOptions: [
                // 可选择的导入方式
                { label: "EXCEL 导入", value: "0" },
              ],
            };
            this.dialogData.title = "实操成绩导入";
            this.dialogData.dialogData = [
              {
                type: "import",
                value: value,
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_import" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;
          case "workLicense":
            // 批量生成上岗证
            this.multipleSelection = [];
            this.dialogData.title = "上岗证生成";
            let vv = {
              time: this.getCurrentDate(),
              options: this.options.opinion,
              opinion:
                this.options.opinion.length > 0
                  ? this.options.opinion[0].value
                  : "",
              fileName: "",
              fileUrl: "",
            };
            this.dialogData.dialogData = [
              {
                type: "import_work_license",
                value: vv,
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_create_work_license_all" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;
          case "end":
            // 考核归档
            this.$confirm(
              "考核归档后,该任务已全部结束,请确保各学员的考核成绩已录入,同时对应上岗证已生成!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                let resultData = await this.$request({
                  url: "/workLicense/endWork",
                  method: "post",
                  data: { id: this.id },
                });
                this.$message({
                  type: "success",
                  message: "考核已归档!",
                });
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消归档",
                });
              });

            break;
          case "echart":
            // 数据概览
            let resultData = {};
            resultData = await this.$request({
              url: "/workLicense/showWorkLicenseDetails",
              method: "post",
              data: { id: this.id },
            });
            let name = resultData.name;
            resultData = await this.$request({
              url: "/statistics/workLicensePass",
              method: "post",
              data: { workId: this.id },
            });
            this.dialogData.title = "上岗证数据统计";
            this.dialogData.dialogData = [
              {
                type: "pie_echart",
                value: {
                  title: name,
                  subTitle: "上岗证管理",
                  yAxis: [
                    { value: resultData.passNum, name: "合格人数" },
                    { value: resultData.notPassNum, name: "不合格人数" },
                  ],
                },
              },
            ];
            this.dialogData.buttonList = [{ text: "取消", active: "cancel" }];
            this.dialogData.flag = true;
            break;
          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 表格按钮操作
     */
    handleClick(data) {
      this.tempUser = JSON.parse(JSON.stringify(data.item));
      try {
        switch (data.active) {
          case "entering":
            // 录入单个学员的实操成绩
            this.dialogData.title = this.tempUser.userName + "实操成绩录入";
            this.dialogData.dialogData = [
              {
                type: "input",
                key: "grade",
                title: "实操成绩",
                placeholder: "请录入学员实操成绩",
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_entering" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;
          case "workLicense":
            // 生成单个学员上岗证
            this.multipleSelection = [];
            this.multipleSelection.push(JSON.parse(JSON.stringify(data.item)));
            this.dialogData.title = this.tempUser.userName + "--上岗证生成";
            this.dialogData.dialogData = [
              {
                type: "time_date",
                value: this.getCurrentDate(),
                title: "发证日期",
                key: "certificateTime",
                isNotNull: true,
              },
              {
                key: "number",
                type: "input",
                value: "",
                title: "上岗证编号",
                isNotNull: true,
              },
              {
                type: "select",
                value:
                  this.options.opinion.length > 0
                    ? this.options.opinion[0].value
                    : "",
                title: "考核意见",
                key: "opinion",
                options: this.options.opinion,
              },
            ];
            this.dialogData.buttonList = [
              { text: "确定", active: "makesure_create_work_license" },
              { text: "取消", active: "cancel" },
            ];
            this.dialogData.flag = true;
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 弹出框中的按钮操作
     */
    async dialogOper(active) {
      try {
        let requestData = {};
        let resultData = {};
        let text = "";
        let uID = [];
        switch (active) {
          case "makesure_import":
            // 确定导入实操成绩
            requestData = {
              id: this.id,
              file: this.dialogData.dialogData[0].value.fileUrl,
            };
            resultData = await this.$request({
              url: "/workLicense/importUserWorkLicenseGrade",
              method: "post",
              data: requestData,
            });
            this.$message.success("导入成功!");
            this.dialogData.flag = false;
            await this.initTable({ pageData: this.pageData });
            break;
          case "makesure_entering":
            // 确定录入某个学员实操成绩
            requestData = {
              workLicenseId: this.id,
              uId: this.tempUser.userId,
            };
            requestData = this.$baseData.array2json(
              this.dialogData.dialogData,
              requestData
            );
            /**
             * 校验实操成绩只能为数字且只能为正数,
             */
            if (!this.$baseData.judgeStringIsNumber(requestData.grade)) {
              throw { message: "实操成绩只能为数字!" };
            }
            if (requestData.grade < 0) {
              throw { message: "实操成绩必须大于等于0!" };
            }
            resultData = await this.$request({
              url: "/workLicense/updateUserWorkLicenseGrade",
              method: "post",
              data: requestData,
            });
            this.$message.success("操作成功!");
            this.dialogData.flag = false;
            await this.initTable({ pageData: this.pageData });
            break;
          case "makesure_create_work_license_all":
            // 确定批量生成上岗证
            /**
             * 若没有勾选表格数据,则批量生成当前考核中的所有已合格学员的上岗证
             * 否则,仅生成已勾选的学员上岗证
             */
            if (this.multipleSelection.length == 0) {
              // 全部
              text = "批量生成当前考核下所有已合格的学员上岗证";
              uID = [];
            } else {
              console.log(this.multipleSelection);
              text = "批量生成所选学员中,考核已合格的学员上岗证";
              this.multipleSelection.forEach((element) => {
                uID.push(element.userId);
              });
            }
            this.$confirm(
              text + ",若部分学员已生成上岗证,系统将覆盖上一次的上岗证!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                try {
                  requestData = {
                    uID: uID,
                    workLicenseId: this.id,
                    time: this.dialogData.dialogData[0].value.time,
                    opinion: this.dialogData.dialogData[0].value.opinion,
                    filePath: this.dialogData.dialogData[0].value.fileUrl,
                  };
                  if (requestData.time == "") {
                    throw { message: "发证日期不可为空!" };
                  }
                  if (requestData.filePath == "") {
                    throw { message: "上岗证编号不可为空!" };
                  }
                  console.log(requestData);
                  resultData = await this.$request({
                    url: "/workLicense/createUserWorkLicense",
                    method: "post",
                    data: requestData,
                  });
                  this.$message({
                    type: "success",
                    message: "上岗证已生成!",
                  });
                  this.dialogData.flag = false;
                } catch (error) {
                  this.$message.error(error.message);
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;
          case "makesure_create_work_license":
            /**
             * 若没有勾选表格数据,则批量生成当前考核中的所有已合格学员的上岗证
             * 否则,仅生成已勾选的学员上岗证
             */
            if (this.multipleSelection.length == 0) {
              // 全部
              text = "批量生成当前考核下所有已合格的学员上岗证";
              uID = [];
            } else {
              console.log(this.multipleSelection);
              text = "批量生成所选学员中,考核已合格的学员上岗证";
              this.multipleSelection.forEach((element) => {
                uID.push(element.userId);
              });
            }
            this.$confirm(
              text + ",若部分学员已生成上岗证,系统将覆盖上一次的上岗证!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            )
              .then(async () => {
                try {
                  requestData = {
                    uID: uID,
                    workUserId: this.tempUser.id,
                  };
                  requestData = this.$baseData.array2json(
                    this.dialogData.dialogData,
                    requestData
                  );
                  resultData = await this.$request({
                    url: "/workLicense/generateWork",
                    method: "post",
                    data: requestData,
                  });
                  this.$message({
                    type: "success",
                    message: "上岗证已生成!",
                  });
                  this.dialogData.flag = false;

                  await this.initTable({ pageData: this.pageData });
                } catch (error) {
                  this.$message.error(error.message);
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;
          case "cancel":
            this.colseDialog();
            break;

          default:
            break;
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 表格多选事件
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 关闭弹出框
     */
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    this.id = this.$route.query.id;
    this.status = this.$route.query.status;
    if (this.status == "已归档") {
      this.tableState = false;
      this.buttonList = this.$systemBaseData.getTopButArray(
        "workLicenseUserOverEchart"
      );
      this.tableButton = [];
    }
    console.log(this.status);
    await this.getListByType();
    await this.initTable({ pageData: this.pageData });
  },
};
</script>

<style lang="less" scoped>
#admin-work-license-user-list {
  width: 100%;
  height: 100%;
}
</style>